import { Field } from "@/lib/form/field"
import { Model } from "@/lib/form/model"
import { RequiredRule } from "@/lib/form/rules/required"

export class ContactForm extends Model {

    get firstName(): Field {
        return this.field("firstName", "First Name", this.initData?.firstName ?? '')
    }

    get lastName(): Field {
        return this.field("lastName", 'Last Name', this.initData?.lastName ?? '')
    }

    get phoneNumber(): Field {
        return this.field("phoneNumber", 'Phone number', this.initData?.phoneNumber ?? '')
    }

    get workEmail(): Field {
        return this.field("workEmail", 'Work email', this.initData?.workEmail ?? '')
    }

    get jobTitle(): Field {
        return this.field("jobTitle", 'Job Title', this.initData?.jobTitle ?? '')
    }

    get companyName(): Field {
        return this.field("companyName", 'Company Name', this.initData?.companyName ?? '')
    }

    get description(): Field {
        return this.field("description", 'Describe your project', this.initData?.description ?? '')
    }

    get rules(): any[] {
        return [
            [[this.firstName,this.lastName,this.phoneNumber,this.workEmail,this.jobTitle,this.companyName,this.description], RequiredRule],

        ]
    }
}
